import { render, staticRenderFns } from "./ReportFilesList.vue?vue&type=template&id=cb1cd1d8"
import script from "./ReportFilesList.vue?vue&type=script&lang=js"
export * from "./ReportFilesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports